import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { ACTIVITY_CATEGORIES } from '../../../consts'
import $t from '../../../i18n'
import ActivityItem from '../../common/ActivityItem'
import Card from '../../common/Card'
import Page from '../../common/Page'
import EmptyList from '../../common/EmptyList'
import {
  getActivityListByMember,
  getEnrollmentPaymentNotification,
  getPaymentReceivedNotification
} from 'utils/activityUtils'
import { usePaymentNotifications } from 'hooks'

import './MyActivity.css'

const MyActivity = () => {
  const dispatch = useDispatch()
  const selectedMember = useSelector(state => state.account?.selectedMember)
  const userDetails = useSelector(state => state.profile?.userDetails)

  const {
    showEnrollmentPaymentNotification,
    showPaymentReceivedNotification,
    hasPinnedPaymentNotification
  } = usePaymentNotifications()

  const categorySelected = useSelector(
    state => state?.notifications?.selectedCategory
  )

  const notificationData = useSelector(state =>
    getActivityListByMember(state?.notifications?.notifications, selectedMember)
  )

  const filterList = useSelector(state =>
    getActivityListByMember(
      state?.notifications?.notificationsByCategory,
      selectedMember
    )
  )

  const getFilterActions = () =>
    Object.values(ACTIVITY_CATEGORIES).map((category, i) => {
      const selected = categorySelected === category
      const count =
        category === ACTIVITY_CATEGORIES.ALL
          ? notificationData?.length
          : notificationData?.filter(item => item?.category === category)
              ?.length
      return (
        <Button
          type="primary"
          key={i}
          className={
            selected ? 'activity-filter-btn selected' : 'activity-filter-btn'
          }
          onClick={() =>
            dispatch(
              Actions.createAction(
                Actions.NOTIFICATIONS_CATEGORY_CHANGED,
                category
              )
            )
          }
        >
          {!!count
            ? `${$t(`homeScreen.myActivity.categories.${category}`)} (${count})`
            : $t(`homeScreen.myActivity.categories.${category}`)}
        </Button>
      )
    })

  return (
    <Page
      displayManageFamily
      title={$t('homeScreen.myActivity.title')}
      className="grey my-activity-page"
    >
      <Card className="my-activity-card">
        <div className="activity-actions-list">{getFilterActions()}</div>
        <div className="my-activity-list">
          {showEnrollmentPaymentNotification && (
            <ActivityItem
              item={getEnrollmentPaymentNotification(
                true,
                userDetails?.hmo_effective_begin_date
              )}
            />
          )}
          {showPaymentReceivedNotification && (
            <ActivityItem item={getPaymentReceivedNotification()} />
          )}
          {filterList.length
            ? filterList?.map((item, index) => (
                <ActivityItem item={item} index={index} />
              ))
            : !hasPinnedPaymentNotification && (
                <EmptyList
                  title={$t('alerts.noItems', {
                    category: $t('sideMenu.futureVisits').toLowerCase(),
                  })}
                />
              )}
        </div>
      </Card>
    </Page>
  )
}

export default MyActivity
